"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialAssessmentFrequencyDetails = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.FinancialAssessmentFrequencyDetails = {
    priority: Number.MAX_VALUE,
    label: 'fields.payload.mor_entity_answers.financial_assessment_frequency_details.label',
    fallbackLabel: 'Please provide a brief explanation for the extended timeframe in renewing merchant\'s financial status.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_entity_answers.financial_assessment_frequency_guideline', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_entity_answers?.financial_assessment_frequency_guideline?.valueOf?.() === 'LESS_THAN_ONCE_A_YEAR'
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return payload.mor_entity_answers?.financial_assessment_frequency_guideline?.valueOf?.() === 'LESS_THAN_ONCE_A_YEAR'
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
